// API request types
export const calenarEntryRequestTypes = [
  "WorktimeEntry",
  "AllUnavailabilityEntries",
]
// API response types
export const calendarEntryTypes = [
  "WorktimeEntry",
  "UnavailabilityEntry",
] as const;

export type CalendarEntryType = (typeof calendarEntryTypes)[number];

export type UnavailabilityType = "fullDay" | "partialDay";

export type CalendarEventTitleKey =
  | "calendar.unavailability.today"
  | "calendar.unavailability.singleDay"
  | "calendar.unavailability.range"
  | "calendar.worktime";

export type CalendarEventTitleParams = {
  dateRange?: string;
};

export interface TalentCalendarEvent {
  id: string;
  start: number; // epoch milliseconds
  end: number | null; // epoch milliseconds, can be null
  type: CalendarEntryType;
}

// Query filters
export interface CalendarEventFilters {
  talentId: string;
  from?: string; // ISO date string
  to?: string;
  types?: string; // comma-separated
}

// Internal calendar event with Date objects
export interface CalendarEvent {
  id: string;
  start: Date;
  end: Date;
  type: CalendarEntryType;
  titleKey: CalendarEventTitleKey;
  titleParams?: CalendarEventTitleParams;
  unavailabilityType?: UnavailabilityType;
}
